export function base64UrlToUint8Array(base64UrlString) {
  const base64 = base64UrlString
    .replace(/-/g, '+')
    .replace(/_/g, '/')
  const padLength = (4 - (base64.length % 4)) % 4
  const padded = base64 + '='.repeat(padLength)
  const binary = atob(padded)
  const array = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i)
  }
  return array
}
export function bufferToBase64Url(buffer) {
  const bytes = new Uint8Array(buffer);
  let str = '';
  for (const byte of bytes) {
    str += String.fromCharCode(byte);
  }
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
export function base64UrlToUint8ArrayReg(base64UrlString) {
  const padding = '='.repeat((4 - base64UrlString.length % 4) % 4);
  const base64 = (base64UrlString + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
}
export function decodeMimeBase64(mimeString) {
  const match = mimeString.match(/=\?BINARY\?B\?(.*)\?=/i)
  if (match && match[1]) {
    return Uint8Array.from(atob(match[1]), c => c.charCodeAt(0)).buffer
  }
  return Uint8Array.from(atob(mimeString), c => c.charCodeAt(0)).buffer
}
export function preformatMakeCredReq(options) {
  const opts = { ...options }
  opts.challenge = decodeMimeBase64(opts.challenge)
  if (opts.user && opts.user.id) {
    opts.user.id = decodeMimeBase64(opts.user.id)
  }
  if (opts.excludeCredentials && Array.isArray(opts.excludeCredentials)) {
    opts.excludeCredentials = opts.excludeCredentials.map(cred => ({
      ...cred,
      id: decodeMimeBase64(cred.id)
    }))
  }
  return opts
}
export function preformatMakeCredseq(credential) {
  const dataToSend = {
    id: credential.id,
    rawId: bufferToBase64Url(credential.rawId),
    type: credential.type,
    response: {
      clientDataJSON: bufferToBase64Url(credential.response.clientDataJSON),
      attestationObject: bufferToBase64Url(credential.response.attestationObject)
    }
  };

  return dataToSend
}
export function preformatCheckCredReq(options) {
  const opts = { ...options }
  opts.challenge = decodeMimeBase64(opts.challenge)
  // opts.timeout = Date.now()+opts.timeout??16000
  // opts.timeout = null
  opts.hints = ["client-device"]

  if (opts.allowCredentials && Array.isArray(opts.allowCredentials)) {
    opts.allowCredentials = opts.allowCredentials.map(cred => ({
      ...cred,
      id: decodeMimeBase64(cred.id)
    }))
  }
  return opts
}
export function filesToBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = (err) => reject(err)
    reader.readAsDataURL(file)
  })
}